import { StudentState } from '../../types/common';

export const getStudentChipLabel = (state: string) => {
  switch (state) {
    case StudentState.PendingAttendance:
      return 'New';
    case StudentState.OnTrial:
      return 'On Trial';
    default:
      return '';
  }
};
